export default __webpack_public_path__ + "static/media/Mansura.99d3dcad.jpeg";